import { Routes } from '@angular/router';
import { ADMIN, NYCDOE_CALLBACK, SCHOOL, STUDENT, USER } from '@app/shared/constant/routes';
import { UserAuthGuard } from '@app/shared/helper/user-auth.guard';
import { PAGE_TITLES } from './shared/constant/page-titles';
import { NycdoeComponent } from './features/user/auth/nyc/nycdoe.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: USER.NAME,
    pathMatch: 'full',
    title: PAGE_TITLES.HOMEPAGE,
  },
  {
    path: USER.NAME,
    loadChildren: () => import('./routes/user/index.routes').then(m => m.USER_ROUTES),
    canActivate: [UserAuthGuard],
  },
  {
    path: STUDENT.NAME,
    loadChildren: () => import('./routes/student/index.routes').then(m => m.STUDENT_ROUTES),
  },
  {
    path: SCHOOL.NAME,
    loadChildren: () => import('./routes/school.routes').then(m => m.SCHOOL_ROUTES),
  },
  {
    path: ADMIN.NAME,
    loadChildren: () => import('./routes/admin.routes').then(m => m.ADMIN_ROUTES),
  },
  {
    path: NYCDOE_CALLBACK.NAME,
    component: NycdoeComponent,
  },
];
